import KNB from '@wmfe/mach-pro-knb';

// 获取 region locale cityId
export const getRegionLocal = () => {
  const SLCompass = Mach.requireModule('SLCompass');
  const { region, cityId } = SLCompass.getCompassInfo() || {};
  const SLMPI18N = Mach.requireModule('Intl');
  const { locale = 'en' } = SLMPI18N.getCurrentLocaleInfo() || {};

  // console.log('{ region, locale,  cityId }', { region, locale, cityId });
  return { region, locale, cityId };
};

function getDeviceInfo() {
  return new Promise((resolve, reject) => {
    KNB.getDeviceInfo({
      sceneToken: '*', //受隐私合规中长期方案影响，IOS需要新增sceneToken字段，安卓不需要，权限名称为 IDFA
      success(data) {
        resolve(data);
      },
      fail(err) {
        reject(err);
      },
    });
  });
}

// 获取设备语言
export const getDeviceLanguage = async () => {
  let language = '';
  try {
    const result: any = await getDeviceInfo();
    language = result?.language;
  } catch {
    // do nothing
  }
  return language;
};

// 获取请求后端的 header 参数
export const getReqHeaderParams = async () => {
  const { region, locale, cityId } = getRegionLocal();
  const { visitInfo } = globalThis?.customerGlobalState || {};

  const deviceLanguage = await getDeviceLanguage();

  const { visitId } = visitInfo || {};

  return {
    region,
    locale,
    cityId,
    visitid: visitId,
    deviceLanguage,
  };
};
